
import { type PropType, computed, defineComponent } from "vue";

import useShadowModel from "../../composables/shadow-model";
import { CSelect } from "../../vuetify-components";

export default defineComponent({
  components: { CSelect },
  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    availableLanguages: {
      type: Object as PropType<Record<string, string | undefined>>,
      required: true,
    },
  },
  emits: {
    "update:modelValue": (_v: string) => true,
  },
  setup(props, { emit }) {
    const selectedLanguage = useShadowModel("modelValue", props, emit);
    const languageList = computed(() => {
      return Object.entries(props.availableLanguages).map(([value, text]) => ({ value, text }));
    });

    return { selectedLanguage, languageList };
  },
});
